import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-bg border-t border-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-89">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-90">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-91">
          <div className="flex flex-col mb-4" data-id="element-92">
            <span className="text-familia-cyan font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-93">
              📚 VITALITY 360™
            </span>
            <span className="text-familia-gray text-xs sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-94">
              Complete Senior Care Master Kit
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-familia-gray mt-8" data-id="element-95">
            <a href="mailto:support@vitality360.com" className="hover:text-familia-cyan transition-colors" data-id="element-96">
              📧 support@vitality360.com
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-97">
              📲 @vitality360
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-98">
              🌐 www.vitality360.com
            </a>
          </div>
        </div>
        <div className="w-full h-px bg-familia-cyan/15 mb-12" data-id="element-99" />
        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed" data-id="element-100">
          <p data-id="element-101">
            © VITALITY 360™ 2026 — All rights reserved. Reproduction without
            express authorization is prohibited.
          </p>
          <p data-id="element-102">
            VITALITY 360™ is a digital educational resource designed to support
            families, caregivers and professionals working with older adults. It
            does not provide medical diagnosis or treatment and is not a
            substitute for advice from a physician, physical therapist,
            registered dietitian or other qualified healthcare professional.
            Always consult a qualified healthcare professional before beginning
            a new exercise, nutrition or care routine, especially when an older
            adult has a medical condition, limited mobility or a history of
            falls. Results and experiences may vary according to each person’s
            health, needs, consistency and level of participation.
          </p>
        </div>
      </div>
    </footer>;
};